import { Routes } from '@angular/router';
import { ChatComponent } from './components/chat/chat.component';
import { LoginComponent } from './components/admin/login/login.component';
import { DashboardComponent } from './components/admin/dashboard/dashboard.component';
import { FaqManagementComponent } from './components/admin/faq-management/faq-management.component';
import { ComplaintsComponent } from './components/admin/complaints/complaints.component';
import { AnalyticsComponent } from './components/admin/analytics/analytics.component';
import { SettingsComponent } from './components/admin/settings/settings.component';
import { ConversationLogComponent } from './components/admin/conversation-log/conversation-log.component';
import { KnowledgebaseComponent } from './components/admin/knowledgebase/knowledgebase.component';
import { QuestionnaireComponent } from './components/questionnaire/questionnaire.component';
import { AdminLayoutComponent } from './components/admin/layout/admin-layout.component';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: '', component: ChatComponent },
  { path: 'self-help', loadComponent: () => import('./components/self-help/self-help.component').then(m => m.SelfHelpComponent) },
  { path: 'emergency', loadComponent: () => import('./components/emergency/emergency.component').then(m => m.EmergencyComponent) },
  { path: 'login', component: LoginComponent },
  { path: 'questionaire', component: QuestionnaireComponent },
  { path: 'questionnaire', redirectTo: 'questionaire', pathMatch: 'full' },
  { 
    path: 'admin', 
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'knowledgebase', component: KnowledgebaseComponent },
      { path: 'faq-management', component: FaqManagementComponent },
      { path: 'faqs', redirectTo: 'faq-management', pathMatch: 'full' },
      { path: 'complaints', component: ComplaintsComponent },
      { path: 'analytics', component: AnalyticsComponent },
      { path: 'conversation-log', component: ConversationLogComponent },
      { path: 'settings', component: SettingsComponent },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: '' }
];

